import { DateTime } from 'luxon'

import { isRewardRequestExpired } from './allowance'

// Prioridade de exibição na lista de resgates de um item (menor = topo):
// 0 aguardando retirada (approved não expirado) — acionável, sobe
// 1 retirado (delivered)
// 2 reembolsado (canceled)
// 3 expirado (approved sem retirada a tempo) — desce pro fim
const groupRank = (request, now) => {
  const { status } = request
  if (status === 'approved') return isRewardRequestExpired(request, now) ? 3 : 0
  if (status === 'delivered') return 1
  if (status === 'canceled') return 2
  if (status === 'expired') return 3
  return 4
}

// Recência: created_at quando disponível, senão id incremental como proxy.
const recency = (request) => {
  if (request.created_at) return DateTime.fromISO(request.created_at).toMillis()
  return request.id ?? 0
}

// Ordena por grupo de prioridade e, dentro do grupo, do mais recente ao mais
// antigo — um novo resgate aparece no topo, não escondido no fim da lista.
export const sortRewardRequests = (rewardRequests = [], now = DateTime.now()) =>
  [...rewardRequests].sort((a, b) => {
    const rankDiff = groupRank(a, now) - groupRank(b, now)
    if (rankDiff !== 0) return rankDiff
    return recency(b) - recency(a)
  })
